import { render, staticRenderFns } from "./CustomerInfoReportV2.vue?vue&type=template&id=2ad28a35&scoped=true"
import script from "./CustomerInfoReportV2.vue?vue&type=script&lang=js"
export * from "./CustomerInfoReportV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad28a35",
  null
  
)

export default component.exports